import { render, staticRenderFns } from "./LazyCrossSelling.vue?vue&type=template&id=40f5dfde&"
import script from "./LazyCrossSelling.vue?vue&type=script&lang=js&"
export * from "./LazyCrossSelling.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\cwallenfang\\Documents\\PlentyDevTool\\2227\\60\\ETCeresCoconut\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('40f5dfde')) {
      api.createRecord('40f5dfde', component.options)
    } else {
      api.reload('40f5dfde', component.options)
    }
    module.hot.accept("./LazyCrossSelling.vue?vue&type=template&id=40f5dfde&", function () {
      api.rerender('40f5dfde', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/components/item/LazyCrossSelling.vue"
export default component.exports